import React, { useMemo, useState } from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountImagePreview.module.sass'
import WImage from '../WImage/WImage'
import { Bin, Download, Image, Pdf, Documents, FileAi, FileEps, Zoom } from '@components/icons'
import ButtonIcon from '../ButtonIcon/ButtonIcon'
import useTrans from '@hooks/useTrans'
import ZoomModal from '@components/organisms/ZoomModal/ZoomModal'


interface Props {
  id?: string // da usare nel caso dello zoom
  url?: string
  downloadUrl?: string
  zoomUrl?: string
  name?: string
  size?: 'sm' | 'lg'
  previewName?: string // per ariaLabel
  badge?: string
  onRemove?: () => void
  className?: string
}

const MyAccountImagePreview = (props: Props) => {

  const { 
    id,
    url,
    downloadUrl = url,
    zoomUrl,
    name,
    previewName,
    size = 'sm',
    badge,
    onRemove,
    className = '',
  } = props

  const t = useTrans()
  const [zoomModalOpen, setZoomModalOpen] = useState(false)
  const ext = useMemo(() => name?.split('.')?.slice(-1)?.[0], [name])
  const supportedExts = ['jpeg', 'jpg', 'png', 'svg']
  const unsupportedExtsIcons = {
    'pdf': <Pdf />,
    'ai': <FileAi />,
    'eps': <FileEps />,
  }
  const unsupportedIcon = Object.keys(unsupportedExtsIcons).includes(ext) ? unsupportedExtsIcons[ext] : <Documents />

  return (
    <div className={cn(styles.root, styles[`root--${size}`],  url ? '' : styles[`root--empty`], supportedExts.includes(ext) ? '' : styles['root--unsupported'], className)}>
      {url ? (
        supportedExts.includes(ext) ? (
          <WImage
            src={url}
            maxWidth={size === 'lg' ? 340 : 160}
            maxHeight={size === 'lg' ? 340 : 160}
          />
        ) : (
          <span className={styles.icon}>
            {unsupportedIcon}
          </span>
        )
      ) : (
        <span className={styles.icon}>
          <Image className={styles.icon} />
        </span>
      )}
      {!!badge && (
        <div className={styles.badge}>{badge}</div>
      )}
      {((!!url && !!onRemove) || !!zoomUrl || !!downloadUrl) && (
        <div className={styles.actions}>
          {zoomUrl ? (
            <>
              <ButtonIcon
                variant="ghost"
                size="md"
                ariaLabel={t("Visualizza {0}", [previewName])}
                icon={<Zoom />}
                onClick={() => setZoomModalOpen(true)}
                newPage
                className={styles.download}
              /> 
              <ZoomModal 
                id={`myaccountpreview_image_${id}_zoommodal`}
                url={zoomUrl}
                open={zoomModalOpen}
                onClose={() => setZoomModalOpen(false)}
                className={styles.zoomModal}
                />
            </>
          ) : <></>}
          {!!downloadUrl && (
            <ButtonIcon
              variant="ghost"
              size="md"
              ariaLabel={t("Download {0}", [previewName])}
              icon={<Download />}
              href={downloadUrl}
              download
              newPage
              className={styles.download}
            />
          )}
          {!!url && !!onRemove && (
            <ButtonIcon
              variant="ghost"
              size="md"
              ariaLabel={t("Rimuovi {0}", [previewName])}
              icon={<Bin />}
              colorVariant='danger'
              className={styles.remove}
              onClick={onRemove}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default MyAccountImagePreview
